export default "__VITE_ASSET__DXD7YxSY__"